export default __webpack_public_path__ + "static/media/logo150.9246a5dd.png";